<template>
  <Transition
    :name="n('--fade')"
    :duration="animationDuration"
  >
    <div
      v-show="visible"
      ref="overlay"
      :class="overlayClassName"
      :style="overlayStyle"
      @click="handleClickOverlay"
    >
      <slot />
    </div>
  </Transition>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'virtual-vue';
import { props } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { preventDefault } from '../utils/dom';
import { useEventListener } from '../use/useEventListener';
import { useLock } from '../use/useLock';

const { name, n, classes } = createNamespace('overlay');

export default defineComponent({
  name,
  props,
  emits,
  setup(props, { emit }) {
    // overlay根元素
    const overlay = ref<null | HTMLElement>(null);
    const overlayClassName = computed(() => [n(), props.overlayClass]);
    // overlay样式
    const overlayStyle = computed(() => ({
      zIndex: props.zIndex,
      transitionDuration: `${props.duration}s`,
    }));
    const animationDuration = computed(() => +props.duration * 1000);


    const onTouchMove = (event: TouchEvent) => {
      if (props.lockScroll) {
        preventDefault(event, true);
      }
    };


    // 对于 lockScroll 为 true 的情况，禁止 touchmove 事件与设置 overflow: hidden 事件结合使用来有效阻止滚动穿透问题
    // 在微信客户端H5&ios18上滚动穿透会失效，需要使用 passive: false
    useEventListener(overlay, 'touchmove', onTouchMove);
    // ⚠️注意：该方法与上面的 touchmove 事件作用相同，在部分 iOS 版本中，仅阻止 touchmove 可能无法完全禁止页面滚动
    // 次要作用于处理 LiteApp 下 window 对象不存在的情况
    useLock(() => props.visible, () => props.lockScroll);

    const handleClickOverlay = () => {
      emit('click');
    };


    return {
      n,
      classes,
      overlay,
      overlayClassName,
      overlayStyle,
      animationDuration,
      handleClickOverlay,
    };
  },
});
</script>
